// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3eSIs","form":"styles_form__vm2bf"};